import { schemeParse } from '@/utils/schemeParse';

import { meetingNoteSummarySchema, type MeetingNoteSummaryResponse } from './types';

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const parseSummary = (value: unknown): MeetingNoteSummaryResponse | null => {
  const result = schemeParse(meetingNoteSummarySchema, value);

  return result.success ? result.data : null;
};
